import { Col, Form, Row } from "react-bootstrap";
import Delete from "../../../../icons/DeleteIcon.svg";
import { getPresignedURL } from "../../../../Services/Welder-services";
import { isAllowCustomSpecialCharacters } from "../../../../functions/validations";
export const FILE_MAX_SIZE = 1 * 1024 * 1024; // 1MB

export const ALLOWED_IMAGE_EXTENSIONS = ["jpeg", "png", "jpg"];

const TUBESHEET_IMAGE_PATH =["tube_Hole_ligament","tube_Hole","tube_Weld_Joint"]
const GROOVE_IMAGE_PATH =["Image1","Image2","Image3"]
/**
 * Common function to fetch presigned URL and set preview
 * @param {string} folder - Folder name for the image
 * @param {string} imagePath - Path to the image
 * @param {Function} setPreviewUrl - Function to set the preview URL
 * @param {string} defaultImg - Default image to use if no image path
 */
export const fetchImagePreview = async (folder, imagePath, setPreviewUrl, defaultImg = null) => {
  try {
    if (imagePath && imagePath !== "") {
      const result = await getPresignedURL(folder, imagePath);
      setPreviewUrl(result.url);
    } else if (defaultImg) {
      setPreviewUrl(defaultImg);
    }
  } catch (error) {
    console.error("Error fetching image:", error);
    if (defaultImg) {
      setPreviewUrl(defaultImg);
    }
  }
};



const handleChange = (index,imagePath,headerObj,setheaderObj,setPreviwURL)=>{
const rootpath = headerObj.wld_WPSType == "Tubesheet" ? "Pdf_images" : "wld_pdf_image"
  const updatedHeaderObj = {...headerObj};
  updatedHeaderObj[rootpath][index][imagePath][0] = "";
  setheaderObj(updatedHeaderObj);
  setPreviwURL("")
}

export const validateFile = (file) => {
  // File size validation
  if (file.size > FILE_MAX_SIZE) {
    alert("File size exceeds the allowed limit. Add File Less Than 1 Mb");
    return false;
  }
  if(isAllowCustomSpecialCharacters(file.name,".").status){
    alert("Special chatracters not allowed in file");
    return false;
  }
  // File extension validation
  const uploadextension = file.name.split(".");
  const extension = uploadextension[uploadextension.length - 1]?.toLowerCase();
  
  if (!ALLOWED_IMAGE_EXTENSIONS.includes(extension)) {
    alert("Please Upload Jpeg, png or jpg images");
    return false;
  }

  return true;
};



// Common image component to reduce duplication
const ImageUploadField = ({ 
  name, 
  previewUrl, 
  headerObj, 
  setheaderObj, 
  handleOndragOver, 
  handleOndrop, 
  handleFile, 
  fileInputRef,
  index,
  disableFields,
  setPreviwURL,
  imagePath, // Path to access the correct property in headerObj

}) => {
  const rootpath = headerObj.wld_WPSType == "Tubesheet" ? "Pdf_images" : "wld_pdf_image"
  let imgaekey =  headerObj[rootpath] && headerObj[rootpath][index][imagePath][0] || ""
  const hasImage = previewUrl !== "" && previewUrl != undefined;
  console.log("image",imagePath,previewUrl)

  return (
    <Col md={4}>
      <Form.Group>
        <form encType="multipart/form-data">
          {hasImage ? (
            <div className="WPS-uploadwhite">
              <img
                src={previewUrl}
                style={{
                  position: "relative",
                  left: "0px",
                  width: "100%"
                }}
                className="WPS-circler"
                alt="Preview"
              />
              <img
                src={Delete}
                style={{
                  position: "relative",
                  top: "15px",
                  height: "30px"
                }}
                className="WPS-circlee"
                alt="Delete"
                onClick={() =>  handleChange(index,imagePath,headerObj,setheaderObj,setPreviwURL)}
              />
            </div>
          ) : (
            <div className="WPS-upload">
               
              <div className="drop_zone"
                onDragOver={handleOndragOver}
                onDrop={handleOndrop}
              >
                <br />
                <Form.Label style={{marginLeft: "60px"}}htmlFor={`fileInput${index + 1}`}>
                  <strong>Upload Image here or</strong>
                  <span className="WPS-blue-text"> Select a file</span>
                </Form.Label>
                <br />
                <span style={{position:"relative", left:"60px", fontSize:"12px"}}>
                  Supports: Jpeg, PNG and JPG, Size:Max 1MB
                </span>
                <div className="ImagenameBox">
                  <Form.Label className="imgtext1">
                    {imgaekey}
                  </Form.Label>
                </div>
                <input
                  id={name}
                  name={name}
                  type="file"
                  accept="image/*"
                  disabled={disableFields}
                  hidden
                  ref={fileInputRef}
                  onChange={(e) => handleFile(e.target.files[0], index)}
                />
              </div>
            </div>
          )}
        </form>
      </Form.Group>
    </Col>
  );
};

const ImageUploader = ({ 
  name, 
  handleFile, 
  handleOndragOver, 
  handleOndrop, 
  previewUrl, 
  fileInputRef,
  accept,
  type,
  index,
  onDelete,
  imageName
}) => {

  return (
    <div className="WPS-upload">
      {previewUrl ? (
        <div className="WPS-uploadwhite">
          <img
            src={previewUrl}
            style={{
              position: "relative",
              left: "0px",
              width: "100%"
            }}
            className="WPS-circler"
            alt="Preview"
          />
          <img
            src={Delete}
            style={{
              position: "relative",
              top: "15px",
              height: "40px"
            }}
            className="WPS-circlee"
            onClick={onDelete}
            alt="Delete"
          />
        </div>
      ) : (
        <>
       
          <div
            className="drop_zone"
            onDragOver={handleOndragOver}
            onDrop={handleOndrop}
          >
            <br />
            <Form.Label style={{marginLeft: "60px"}} htmlFor={name}>
              <strong>Upload Image here or</strong>
              <span className="WPS-blue-text"> Select a file</span>
            </Form.Label>
            <br />
            <span 
              style={{
                position: "relative",
                left: "60px",
                fontSize: "12px"
              }}
            >
              Supports: Jpeg, PNG and JPG, Size:Max 1MB
            </span>

            <div className="ImagenameBox">
              <Form.Label className="imgtext1">{imageName}</Form.Label>
            </div>

            <input
              id={name}
              name={name}
              type={type}
              accept={accept}
              hidden
              ref={fileInputRef}
              onChange={(e) => handleFile(e.target.files[0], index)}
            />
          </div>
        </>
      )}
    </div>
  );
};

export const ImageArray2 = ({
  name1,
  name2,
  type,
  accept,
  fileInputRef,
  handleOndragOver,
  handleOndrop,
  headerObj,
  setheaderObj,
  previewUrl1,
  previewUrl2,
  handleFile,
  setPreviewUrl1,
  setPreviewUrl2
}) => {
 
console.log("inside image array 2: ", previewUrl1, previewUrl2)

  const handleDelete = (index) => {
    const updatedHeaderObj = { ...headerObj };
    updatedHeaderObj.Pdf_images[index][`pqr_image${index + 1}`][0] = "";
    console.log("pqr_image",updatedHeaderObj.Pdf_images)
    setheaderObj(updatedHeaderObj);
    if(index==0) setPreviewUrl1("") 
      else setPreviewUrl2("")
  };

  return (
    <Row>
      {[0, 1].map((index) => (
      
        <Col md={4} key={index}>
          <Form.Group>
            <form encType="multipart/form-data">
              <ImageUploader
                name={index === 0 ? name1 : name2}
                handleFile={handleFile}
                handleOndragOver={handleOndragOver}
                handleOndrop={handleOndrop}
                previewUrl={index === 0 ? previewUrl1 : previewUrl2}
                fileInputRef={fileInputRef}
                accept={accept}
                type={type}
                index={index}
                onDelete={() => handleDelete(index)}
                imageName={headerObj?.Pdf_images?.[index]?.[`pqr_image${index + 1}`]?.[0] || ""}
              />
            </form>
            &nbsp;&nbsp;
          </Form.Group>
        </Col>
      ))}
    </Row>
  );
};


export const ImageArray3 = ({
  name1,
  name2,
  name3,

  fileInputRef,
  handleOndragOver,
  handleOndrop,
  headerObj,
  setheaderObj,
  previewUrl1,
  previewUrl2,
  previewUrl3,
  setPreviewUrl1,
  setPreviewUrl2,
  setPreviewUrl3,
  handleFile,
  disableFields
}) => {
  
  const imageFields = [
    {
      name: name1,
      previewUrl: previewUrl1,
      imagePath: headerObj.wld_WPSType == "Tubesheet" ? TUBESHEET_IMAGE_PATH[0] : GROOVE_IMAGE_PATH[0],
      setPreviwURL:setPreviewUrl1
    },
    {
      name: name2,
      previewUrl: previewUrl2,
      imagePath: headerObj.wld_WPSType == "Tubesheet" ? TUBESHEET_IMAGE_PATH[1] : GROOVE_IMAGE_PATH[1],
      setPreviwURL:setPreviewUrl2
    },
    {
      name: name3,
      previewUrl: previewUrl3,
      imagePath:  headerObj.wld_WPSType == "Tubesheet" ? TUBESHEET_IMAGE_PATH[2] : GROOVE_IMAGE_PATH[2],
      setPreviwURL:setPreviewUrl3
    }
  ];


  console.log("image",imageFields)
  return (
    <Row>
      {imageFields.map((field, index) => (
        <ImageUploadField
          key={field.name}
          {...field}
          headerObj={headerObj}
          setheaderObj={setheaderObj}
          handleOndragOver={handleOndragOver}
          handleOndrop={handleOndrop}
          handleFile={handleFile}
          fileInputRef={fileInputRef}
          index={index}
          imagePath={field.imagePath}
          previewUrl={field.previewUrl}
          disableFields={disableFields}
          setPreviwURL={field.setPreviwURL}
        />
      ))}
    </Row>
  );
};